import React from "react";
import {LOAN_LIBRARY_LOAN_STATUS_LIST_FOR_UPDATE} from "./loanLibraryLoanConstants";
import {LOAN_LIBRARY_LOAN_STATUS} from "../../../Library/LoanLibrary/LoanLibraryQueue/loanLibraryQueueFactory";
import {NumberField, SelectField, TextArea, TextField} from "../../../../Components/Inputs";
import {convertCamelCaseToSpaceDelimited} from "../../../../Utilities/commonUtilities";
import {LoanLibraryLoanItem} from "./loanLibraryLoan.types";

interface LoanLibraryLoanEditFormViewProps {
    loanLibraryLoanItemForDialog: LoanLibraryLoanItem;
    setLoanLibraryLoanItemForDialog: (item: LoanLibraryLoanItem) => void;
}

export const LoanLibraryLoanEditFormView = ({
    loanLibraryLoanItemForDialog,
    setLoanLibraryLoanItemForDialog
}: LoanLibraryLoanEditFormViewProps) => {

    const handleLoanStatusChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setLoanLibraryLoanItemForDialog({...loanLibraryLoanItemForDialog, loanLibraryLoanStatus: event.target.value});
    }

    const handleLoanNotesChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setLoanLibraryLoanItemForDialog({...loanLibraryLoanItemForDialog, loanLibraryLoanNotes: event.target.value});
    }

    const handleLoanItemNotesChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setLoanLibraryLoanItemForDialog({...loanLibraryLoanItemForDialog, loanItemNotes: event.target.value});
    }

    const handleNumberOfExtensionDaysChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;

        const parsedValue = value === '' ? null : parseInt(value, 10);
        setLoanLibraryLoanItemForDialog({
            ...loanLibraryLoanItemForDialog, 
            numberOfExtensionDays: parsedValue !== null && isNaN(parsedValue) ? null : parsedValue
        });
    }

    const isExtensionStatus = Number(loanLibraryLoanItemForDialog.loanLibraryLoanStatus) === LOAN_LIBRARY_LOAN_STATUS.Extension;

    return <>
            <SelectField
                includeDefaultOption={false}
                label={convertCamelCaseToSpaceDelimited("LoanStatus", true)}
                name={"LoanStatus"}
                onChange={handleLoanStatusChange}
                options={LOAN_LIBRARY_LOAN_STATUS_LIST_FOR_UPDATE}
                value={loanLibraryLoanItemForDialog.loanLibraryLoanStatus}
            />

            {isExtensionStatus && (
                <NumberField
                    isPositiveNumberOnly={true}
                    isWholeNumberOnly={true}
                    label={"Number Of Extension Days"}
                    helpText={"Leave empty to use default loan duration"}
                    maxValue={999}
                    name={"numberOfExtensionDays"}
                    onChange={handleNumberOfExtensionDaysChange}
                    value={loanLibraryLoanItemForDialog.numberOfExtensionDays ?? ""}
                />
            )}

            <TextArea
                label={"Loan Notes"}
                name={"loanNotes"}
                onChange={handleLoanNotesChange}
                value={loanLibraryLoanItemForDialog.loanLibraryLoanNotes}
            />

        <div className="form-section-divider"
             style={{marginTop: '20px', marginBottom: '15px', borderTop: '1px solid #ddd', paddingTop: '15px'}}>
            <h4 style={{marginTop: 0, marginBottom: '10px'}}>Loan Item Information</h4>
        </div>

        <TextField
            label="Catalog Number"
            name="catalogNumber"
            value={loanLibraryLoanItemForDialog.catalogNumber || ""}
            disabled={true}
        />
        <TextField
            label="Serial Number"
            name="serialNumber"
            value={loanLibraryLoanItemForDialog.serialNumber || ""}
            disabled={true}

        />
        <TextField
            label="Asset Number"
            name="assetNumber"
            value={loanLibraryLoanItemForDialog.assetNumber || ""}
            disabled={true}

        />
        <TextArea
            label="Loan Item Notes"
            name="loanItemNotes"
            value={loanLibraryLoanItemForDialog.loanItemNotes || ""}
            onChange={handleLoanItemNotesChange}
        />

    </>;
};

